export const formatAbn = (abn: string | undefined) => (abn ? abn.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : abn);
